<template>
  <div :v-if="isOpen">
    <Modal :is-open="isOpen">
      <template #form>
        <h3 class="text-2xl font-medium leading-10 text-left text-gray-600 dark:text-white">
          {{ $t("Map Company ID Field") }}
        </h3>
        <p class="text-sm text-gray-500">
          {{
            $t(
              "Select the integration and field that this company ID field should be mapped to. This will establish the parent-child relationship between objects."
            )
          }}
        </p>
        <Form v-slot="{ values }" :validation-schema="schema" :initial-values="initial_values" @submit="submitMappedMetric">
          <div class="flex flex-col justify-between flex-1">
            <div class="mt-6 space-y-6">
              <div class="mt-1">
                <ComboBoxInput
                  :items="utils.SortedObjectTypes()"
                  classes="w-full relative dark:text-white"
                  label-attr="label"
                  value-attr="type"
                  name="parent_object_type"
                  :return-value="true"
                  :is-box-background="true"
                  :label="$t('Object Type')"
                  :tooltip-info="$t('Select object type here')"
                  :show-label="true"
                  :floating-label="true"
                  :allow-null="false" />
              </div>

              <ComboBoxInput
                :items="
                  $store.state.metrics.filter(
                    (x) => x.object_type == values.parent_object_type && (x.data_type == 'Number' || x.data_type == 'String')
                  )
                "
                name="parent_metric"
                classes="w-full relative dark:text-white"
                label-attr="name"
                value-attr="id"
                :return-value="true"
                :is-box-background="true"
                :label="$t('Metric')"
                :tooltip-info="$t('Select Parent metric here')"
                :show-label="true"
                :floating-label="true"
                :allow-null="false" />
            </div>
          </div>

          <div class="flex flex-row justify-between w-full gap-2 mt-2">
            <div class="w-1/2 m-0 cancel-btn" @click="$emit('update:isOpen', false)">
              {{ $t("Cancel") }}
            </div>
            <button type="submit" class="w-1/2 primary-btn">{{ $t("Submit") }}</button>
          </div>
        </Form>
      </template>
    </Modal>
  </div>
</template>

<script>
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import Modal from "@/components/shared/Modal.vue"
import { utils } from "@/store/helpers"
import * as Yup from "yup"
import { Form } from "vee-validate"

export default {
  name: "CompanyFieldMapping",
  components: {
    Form,
    Modal,
    ComboBoxInput
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:isOpen", 'submitParentMapping'],
  data() {
    return {
      utils,
      initial_values: {},
      schema: null
    }
  },

  async created() {
    this.initial_values = {
      parent_object_type: "company",
      parent_metric: utils.getOptionMetricReference("company", "id", "id")
    }
    this.schema = Yup.object().shape({
      parent_object_type: Yup.string().required(this.$t("object type is required")),
      parent_metric: Yup.string().required(this.$t("metric is required"))
    })
  },
  methods: {
    submitMappedMetric(values) {
      // Prepare mapping data
      const mappingData = {
        object_type: values.parent_object_type,
        metric_id: values.parent_metric
      }

      // Emit the saved data to parent
      this.$emit("submitParentMapping", mappingData)
    }
  }
}
</script>
